'use client';
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { createElement as _createElement } from "react";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Autocomplete, Box, Button, Checkbox, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, FormHelperText, Grid, IconButton, TextField, Typography, useTheme } from '@mui/material';
import { nanoid } from '@reduxjs/toolkit';
import { debounce } from 'lodash';
import { enqueueSnackbar } from 'notistack';
import * as pdfJs from 'pdfjs-dist';
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { Info, X } from 'react-feather';
import { Controller, useFieldArray, useForm } from 'react-hook-form';
import { RoleCategories } from '../../../../application/common/constants/role-categories';
import { FileErrorType } from '../../../../application/common/enums/file-error-type';
import { useGetAllClientsByCompanyQuery } from '../../../../application/features/clients/client-api';
import { useGetAllCompaniesQuery } from '../../../../application/features/companies/company-api';
import { useCreateAndLinkMachineMutation, useLazyGetMatchingMachinesQuery } from '../../../../application/features/machines/machine-api';
import { useAppSelector } from '../../../../application/store/useStore';
import useTranslate from '../../../../localization/helpers';
import { FolderUploadDialog } from './folder-upload-dialog';
import MatchingAsset from './matching-asset';
import ModelNumberBox from './model-numbers-box';
pdfJs.GlobalWorkerOptions.workerSrc = "https://unpkg.com/pdfjs-dist@".concat(pdfJs.version, "/build/pdf.worker.min.mjs");
var AddMachine = function (_a) {
    var open = _a.open, onClose = _a.onClose;
    var theme = useTheme();
    var _b = useTranslate(), translate = _b.translate, tWithField = _b.tWithField, tWithFunction = _b.tWithFunction;
    var currentCompany = useAppSelector(function (state) { return state.common; }).currentCompany;
    var currentUser = useAppSelector(function (state) { return state.auth; }).currentUser;
    var _c = __read(useLazyGetMatchingMachinesQuery(), 2), fetchMatchingMachines = _c[0], _d = _c[1], matchingMachinesData = _d.data, isMatchingLoading = _d.isLoading, isMatchingFetching = _d.isFetching;
    var _e = __read(useState({
        hasError: false,
        errorType: FileErrorType.NoError
    }), 2), fileError = _e[0], setFileError = _e[1];
    var autocompleteRef = useRef(null);
    var _f = __read(useState(false), 2), openAutoComplete = _f[0], setOpenAutoComplete = _f[1];
    var _g = __read(useState(null), 2), searchName = _g[0], setSearchName = _g[1];
    var _h = __read(useState(null), 2), searchBrand = _h[0], setSearchBrand = _h[1];
    var _j = __read(useState(null), 2), searchType = _j[0], setSearchType = _j[1];
    var _k = __read(useState([]), 2), searchModelNumbers = _k[0], setSearchModelNumbers = _k[1];
    var _l = __read(useState([]), 2), linkedMatchingMachines = _l[0], setLinkedMatchingMachines = _l[1];
    var _m = __read(useState([]), 2), modelsMadePublic = _m[0], setModelsMadePublic = _m[1];
    var _o = __read(useState([]), 2), modelsWithErrors = _o[0], setModelsWithErrors = _o[1];
    var _p = __read(useState({}), 2), publicFileErrors = _p[0], setPublicFileErrors = _p[1];
    var _q = __read(useState({}), 2), privateFileErrors = _q[0], setPrivateFileErrors = _q[1];
    var _r = __read(useState(false), 2), showFileSizeError = _r[0], setShowFileSizeError = _r[1];
    var _s = __read(useState(false), 2), isFolderUploadDialogOpen = _s[0], setIsFolderUploadDialogOpen = _s[1];
    var _t = __read(useState(false), 2), isProcessingFolderUpload = _t[0], setIsProcessingFolderUpload = _t[1];
    var _u = __read(useState(null), 2), folderUploadDialogData = _u[0], setFolderUploadDialogData = _u[1];
    var _v = useGetAllCompaniesQuery({
        filterByCompany: true
    }), _w = _v.data, companies = _w === void 0 ? [] : _w, isCompaniesLoading = _v.isLoading, isCompaniesFetching = _v.isFetching;
    var _x = __read(useCreateAndLinkMachineMutation(), 2), triggerCreateAndLinkMachine = _x[0], _y = _x[1], isLoading = _y.isLoading, isSuccess = _y.isSuccess;
    var _z = useForm({
        defaultValues: {
            name: '',
            type: '',
            brand: '',
            clients: [],
            companies: [],
            machineData: [
                {
                    modelNumber: '',
                    files: [],
                    serialNumbers: [
                        {
                            serialNumber: ''
                        }
                    ]
                }
            ]
        }
    }), control = _z.control, trigger = _z.trigger, reset = _z.reset, handleSubmit = _z.handleSubmit, setError = _z.setError, watch = _z.watch, setValue = _z.setValue, clearErrors = _z.clearErrors, errors = _z.formState.errors;
    var _0 = useFieldArray({
        name: 'machineData',
        control: control
    }), fields = _0.fields, append = _0.append, remove = _0.remove;
    var currentCompanies = watch('companies');
    var currentClients = watch('clients');
    var machineData = watch('machineData');
    var allFiles = machineData
        .flatMap(function (data) { return data.files || []; })
        .filter(function (file) { return file.isPublic; })
        .map(function (file) { return file.fileName; });
    var linkedFiles = machineData
        .flatMap(function (data) { return data.files || []; })
        .filter(function (file) { return file.isLinked; });
    var fileDetails = machineData.flatMap(function (data) { return data.files || []; });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    var triggerMatchingFetch = useCallback(debounce(function () {
        var _a, _b, _c;
        var currentMachineData = watch('machineData');
        var linkedFiles = currentMachineData
            .flatMap(function (data) { return data.files || []; })
            .filter(function (file) { return file.isLinked && file.isPublic; });
        var name;
        var brand;
        var type;
        var modelNumbers;
        if (linkedFiles.length === 0) {
            name = watch('name');
            brand = watch('brand');
            type = watch('type');
            modelNumbers = currentMachineData.map(function (data) { return data.modelNumber; });
            setSearchName(name);
            setSearchBrand(brand);
            setSearchType(type);
            setSearchModelNumbers(modelNumbers);
        }
        else {
            name = searchName;
            brand = searchBrand;
            type = searchType;
            modelNumbers = searchModelNumbers;
        }
        var files = currentMachineData
            .flatMap(function (data) { return data.files || []; })
            .filter(function (file) { return file.uploaded === true && file.isPublic; })
            .map(function (file) { return file.fileName; });
        var isValidNameSearch = name !== null && (name.length > 2 || name.length === 0);
        var isValidTypeSearch = type !== null && (type.length > 2 || type.length === 0);
        var isValidBrandSearch = brand !== null && (brand.length > 2 || brand.length === 0);
        var isValidFiles = files.length > 0;
        if (isValidNameSearch || isValidTypeSearch || isValidBrandSearch || isValidFiles) {
            fetchMatchingMachines({
                name: (_a = name === null || name === void 0 ? void 0 : name.trim()) !== null && _a !== void 0 ? _a : null,
                brand: (_b = brand === null || brand === void 0 ? void 0 : brand.trim()) !== null && _b !== void 0 ? _b : null,
                type: (_c = type === null || type === void 0 ? void 0 : type.trim()) !== null && _c !== void 0 ? _c : null,
                modelNumbers: modelNumbers,
                files: files
            });
        }
    }, 500), [fetchMatchingMachines, searchName, searchBrand, searchType, searchModelNumbers]);
    var selectedCompanyId = useMemo(function () {
        if ((currentUser === null || currentUser === void 0 ? void 0 : currentUser.roleCategory) === RoleCategories.SuperAdmin) {
            return (currentCompanies === null || currentCompanies === void 0 ? void 0 : currentCompanies.length) === 1 ? currentCompanies[0].id : undefined;
        }
        else {
            return currentCompany === null || currentCompany === void 0 ? void 0 : currentCompany.id;
        }
    }, [currentCompanies, currentCompany === null || currentCompany === void 0 ? void 0 : currentCompany.id, currentUser === null || currentUser === void 0 ? void 0 : currentUser.roleCategory]);
    var _1 = useGetAllClientsByCompanyQuery(selectedCompanyId), _2 = _1.data, clients = _2 === void 0 ? [] : _2, clientsFetching = _1.isFetching;
    useEffect(function () {
        if ((currentCompanies === null || currentCompanies === void 0 ? void 0 : currentCompanies.length) > 1) {
            setValue('clients', []);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentCompanies]);
    useEffect(function () {
        if (isSuccess) {
            enqueueSnackbar(tWithField('toolTips.createSuccess', 'common.asset'), {
                autoHideDuration: 3000,
                variant: 'success',
                anchorOrigin: { horizontal: 'right', vertical: 'top' }
            });
            closeDialog();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isSuccess]);
    // Remove model index from modelsMadePublic if its files are empty
    useEffect(function () {
        setModelsMadePublic(function (prev) { return prev.filter(function (idx) { var _a, _b, _c; return ((_c = (_b = (_a = machineData[idx]) === null || _a === void 0 ? void 0 : _a.files) === null || _b === void 0 ? void 0 : _b.length) !== null && _c !== void 0 ? _c : 0) > 0; }); });
    }, [machineData]);
    useEffect(function () {
        var uploadedFiles = machineData
            .flatMap(function (data) { return data.files || []; })
            .filter(function (file) { return !file.isLinked; })
            .reduce(function (sum, file) { var _a; return sum + (((_a = file.uploadedFile) === null || _a === void 0 ? void 0 : _a.size) || 0); }, 0);
        var totalMB = uploadedFiles / (1024 * 1024);
        setShowFileSizeError(totalMB > 100);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [allFiles]);
    var closeDialog = function () {
        reset();
        setPublicFileErrors({});
        setPrivateFileErrors({});
        setModelsWithErrors([]);
        onClose();
    };
    var clearSerialNumbersIfMultipleClients = function (machineData) {
        return machineData.map(function (data) { return ({
            modelNumber: data.modelNumber,
            files: data.files,
            serialNumbers: []
        }); });
    };
    var findDuplicateSerialNumber = function (machineData) {
        var allSerialNumbers = machineData.flatMap(function (model, modelIndex) {
            return model.serialNumbers
                .filter(function (s) { return s.serialNumber.trim() !== ''; })
                .map(function (s, serialIndex) { return ({
                serialNumber: s.serialNumber.trim().toLowerCase(),
                modelIndex: modelIndex,
                serialIndex: serialIndex
            }); });
        });
        var serialNumberMap = new Map();
        allSerialNumbers.forEach(function (_a) {
            var serialNumber = _a.serialNumber, modelIndex = _a.modelIndex, serialIndex = _a.serialIndex;
            if (!serialNumberMap.has(serialNumber)) {
                serialNumberMap.set(serialNumber, []);
            }
            serialNumberMap.get(serialNumber).push({ modelIndex: modelIndex, serialIndex: serialIndex });
        });
        var hasDuplicates = false;
        serialNumberMap.forEach(function (occurrences) {
            if (occurrences.length > 1) {
                hasDuplicates = true;
                occurrences.forEach(function (_a) {
                    var modelIndex = _a.modelIndex, serialIndex = _a.serialIndex;
                    setError("machineData.".concat(modelIndex, ".serialNumbers.").concat(serialIndex, ".serialNumber"), {
                        message: tWithField('validations.isUnique', 'assets.serialNumber')
                    });
                });
            }
        });
        return !hasDuplicates;
    };
    var handleAddModelNumber = function () {
        var machineData = {
            modelNumber: '',
            files: [],
            serialNumbers: [{ serialNumber: '' }]
        };
        append(machineData);
    };
    // Helper function to normalize fileName for matching (removes (1), (2), etc. suffixes)
    var normalizeFileName = function (fileName) {
        // Remove patterns like " (1)", " (2)", etc. before the file extension
        return fileName.replace(/\s*\(\d+\)(\.[^.]+)?$/, '$1');
    };
    var handleLinkAndUnlink = function (linkedDocs, unLinkedDocs, linkTo, modelNumber, title) {
        if (!linkedDocs.length && !unLinkedDocs.length)
            return;
        var documentIdsToUnlink = new Set(unLinkedDocs.map(function (doc) { return doc.documentId; }));
        var fileNamesToUnlink = new Set(unLinkedDocs.map(function (doc) { return doc.fileName; }));
        var newMachineData = __spreadArray([], __read(machineData), false);
        // --- 1. Unlink docs from ALL entries ---
        newMachineData = newMachineData.map(function (entry) { return (__assign(__assign({}, entry), { files: (entry.files || []).reduce(function (acc, file) {
                if (file.isLinked &&
                    (fileNamesToUnlink.has(file.fileName) ||
                        (file.linkedDocumentId && documentIdsToUnlink.has(file.linkedDocumentId)))) {
                    if (file.uploaded) {
                        // For uploaded files, keep the file but set isLinked=false and linkedDocumentId=null
                        acc.push(__assign(__assign({}, file), { isLinked: false, linkedDocumentId: null }));
                    }
                    // For non-uploaded files, skip adding to the array (effectively removing them)
                }
                else {
                    acc.push(file);
                }
                return acc;
            }, []) })); });
        // --- 2. Find ALL target entries ---
        var targetIndexes = [];
        if (modelNumber) {
            var normalizedModelNumber_1 = modelNumber.trim().toLowerCase();
            targetIndexes = newMachineData
                .map(function (entry, idx) {
                return entry.modelNumber.trim().toLowerCase() === normalizedModelNumber_1 ? idx : -1;
            })
                .filter(function (idx) { return idx !== -1; });
        }
        // Match by fileName in any entry or by fileNames in linkTo array
        linkedDocs.forEach(function (doc) {
            newMachineData.forEach(function (entry, idx) {
                if ((entry.files || []).some(function (file) {
                    return file.fileName === doc.fileName || (linkTo.includes(file.fileName) && file.uploaded);
                })) {
                    if (!targetIndexes.includes(idx)) {
                        targetIndexes.push(idx);
                    }
                }
            });
        });
        // --- 3. If no matching entries found, create one (only if linking docs) ---
        if (targetIndexes.length === 0 && linkedDocs.length > 0) {
            var newEntry = {
                modelNumber: modelNumber || '',
                serialNumbers: [],
                files: []
            };
            newMachineData.push(newEntry);
            targetIndexes = [newMachineData.length - 1];
        }
        // --- 4. Link docs into ALL target entries ---
        targetIndexes.forEach(function (idx) {
            var targetEntry = newMachineData[idx];
            var updatedFiles = __spreadArray([], __read((targetEntry.files || [])), false);
            var hasPublicFilesBefore = updatedFiles.some(function (f) { return f.isPublic; });
            linkedDocs.forEach(function (doc) {
                // Find if this document exists in public section (match by fileName, with normalization to handle duplicates)
                var normalizedDocFileName = normalizeFileName(doc.fileName);
                var publicFileIndex = updatedFiles.findIndex(function (file) {
                    return file.isPublic &&
                        (file.fileName === doc.fileName ||
                            normalizeFileName(file.fileName) === normalizedDocFileName);
                });
                if (publicFileIndex >= 0) {
                    // Document exists in public - just mark it as linked (preserve existing fileName to avoid renaming)
                    updatedFiles[publicFileIndex] = __assign(__assign({}, updatedFiles[publicFileIndex]), { isLinked: true, linkedDocumentId: doc.documentId });
                }
                else {
                    // Document doesn't exist in public - add as new linked public document
                    updatedFiles.push({
                        id: nanoid(),
                        uploadedFile: null,
                        uploaded: false,
                        fileName: doc.fileName,
                        isDownloadable: false,
                        isLinked: true,
                        linkedDocumentId: doc.documentId,
                        isPublic: true
                    });
                }
            });
            newMachineData[idx] = __assign(__assign({}, targetEntry), { modelNumber: targetEntry.modelNumber || modelNumber || '', files: updatedFiles });
            // Set wasMadePublic state if there are now public files and there weren't before
            var hasPublicFilesAfter = updatedFiles.some(function (f) { return f.isPublic; });
            if (!hasPublicFilesBefore && hasPublicFilesAfter) {
                setModelsMadePublic(function (prev) { return __spreadArray(__spreadArray([], __read(prev), false), [idx], false); });
            }
        });
        // --- 5. REMOVE any completely empty entries (no model, no title, no files, no serials) ---
        var cleanedMachineData = newMachineData.filter(function (entry) {
            var _a, _b, _c, _d;
            var hasModel = ((_a = entry.modelNumber) !== null && _a !== void 0 ? _a : '').trim().length > 0;
            var hasFiles = ((_c = (_b = entry.files) === null || _b === void 0 ? void 0 : _b.length) !== null && _c !== void 0 ? _c : 0) > 0;
            var hasSerials = ((_d = entry.serialNumbers) !== null && _d !== void 0 ? _d : []).some(function (s) { var _a; return ((_a = s.serialNumber) !== null && _a !== void 0 ? _a : '').trim().length > 0; });
            return hasModel || hasFiles || hasSerials;
        });
        // Push back to form + validate (so title-required kicks in if files were linked)
        setValue('machineData', cleanedMachineData, { shouldValidate: true, shouldDirty: true });
    };
    var handleDelink = function (documentIds) {
        var docs = new Set(machineData
            .filter(function (m) { return m.files.some(function (f) { return documentIds.includes(f.id); }); })
            .flatMap(function (m) { return m.files.map(function (f) { return f.linkedDocumentId; }); })
            .filter(function (id) { return id !== null; }));
        var machineIds = linkedMatchingMachines
            .filter(function (l) {
            return l.modelsWithDocuments.some(function (m) { return m.documents.some(function (d) { return docs.has(d.documentId); }); });
        })
            .map(function (l) { return l.id; });
        var linkedDocumentIds = new Set(machineData
            .flatMap(function (data) { return data.files; })
            .filter(function (file) { return documentIds.includes(file.id) && file.isLinked; })
            .map(function (file) { return file.linkedDocumentId; }));
        var newMachineData = machineData.map(function (data) { return (__assign(__assign({}, data), { files: (data.files || []).reduce(function (acc, file) {
                if (!file.isLinked ||
                    !file.linkedDocumentId ||
                    !linkedDocumentIds.has(file.linkedDocumentId) ||
                    !documentIds.includes(file.id)) {
                    return __spreadArray(__spreadArray([], __read(acc), false), [file], false);
                }
                if (file.uploaded) {
                    return __spreadArray(__spreadArray([], __read(acc), false), [
                        __assign(__assign({}, file), { isLinked: false, linkedDocumentId: null })
                    ], false);
                }
                return acc;
            }, []) })); });
        machineIds.forEach(function (machineId) {
            // Count how many documents being delinked belong to this specific machine
            var linkedMatchingMachine = linkedMatchingMachines.find(function (m) { return m.id === machineId; });
            if (linkedMatchingMachine) {
                var machineDocIds_1 = new Set(linkedMatchingMachine.modelsWithDocuments.flatMap(function (m) {
                    return m.documents.map(function (d) { return d.documentId; });
                }));
                // Count how many of the documents being delinked belong to this machine
                var docsBeingDelinkedFromThisMachine = Array.from(linkedDocumentIds).filter(function (docId) { return docId && machineDocIds_1.has(docId); }).length;
                // Count how many total documents from this machine are currently linked in machineData
                var totalLinkedDocsFromThisMachine = machineData
                    .flatMap(function (data) { return data.files; })
                    .filter(function (file) {
                    return file.isLinked && file.linkedDocumentId && machineDocIds_1.has(file.linkedDocumentId);
                }).length;
                // Only removeAll if we're delinking multiple documents from this specific machine
                // AND we're delinking ALL the documents from this machine
                var removeAll = docsBeingDelinkedFromThisMachine > 1 &&
                    docsBeingDelinkedFromThisMachine === totalLinkedDocsFromThisMachine;
                handleRemoveLinkedMatchingMachine(machineId, removeAll);
            }
        });
        setValue('machineData', newMachineData);
    };
    var handleCreateAsset = function (machine) {
        var isValid = findDuplicateSerialNumber(machine.machineData);
        if (isValid) {
            if (currentClients.length > 1) {
                machine.machineData = clearSerialNumbersIfMultipleClients(machine.machineData);
            }
            machine.companies = (currentCompanies === null || currentCompanies === void 0 ? void 0 : currentCompanies.length) >= 1 ? currentCompanies : [currentCompany];
            machine.machineData
                .flatMap(function (data) { return data.files; })
                .forEach(function (file) {
                if (file.isLinked)
                    file.uploadedFile = null;
            });
            triggerCreateAndLinkMachine(machine);
        }
    };
    var handleSetLinkedMatchingMachine = function (machineId) {
        var linkedMachine = matchingMachinesData === null || matchingMachinesData === void 0 ? void 0 : matchingMachinesData.find(function (machine) { return machine.id === machineId; });
        if (linkedMachine) {
            setLinkedMatchingMachines(function (prev) {
                if (prev.some(function (m) { return m.id === machineId; })) {
                    return prev;
                }
                return __spreadArray(__spreadArray([], __read(prev), false), [linkedMachine], false);
            });
        }
    };
    var handleRemoveLinkedMatchingMachine = function (machineId, removeAll) {
        var linkedMatchingMachine = linkedMatchingMachines.find(function (m) { return m.id === machineId; });
        if (linkedMatchingMachine) {
            var machineDocs_1 = new Set(linkedMatchingMachine.modelsWithDocuments.flatMap(function (m) {
                return m.documents.flatMap(function (d) { return d.documentId; });
            }));
            var linkedDocs_1 = machineData.flatMap(function (m) {
                return m.files.filter(function (f) { return machineDocs_1.has(f.linkedDocumentId); });
            }).length;
            setLinkedMatchingMachines(function (prev) {
                return linkedDocs_1 === 1 || removeAll ? prev.filter(function (m) { return m.id !== machineId; }) : prev;
            });
        }
    };
    return (_jsxs(_Fragment, { children: [_jsxs(Dialog, { sx: { borderRadius: '44px' }, fullWidth: true, scroll: 'paper', open: open && !isFolderUploadDialogOpen, maxWidth: 'lg', children: [_jsxs(DialogTitle, { style: {
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            fontSize: '20px'
                        }, children: [tWithFunction('actions.addFunction', 'common.asset'), _jsx(IconButton, { size: 'Xs', color: 'inherit', style: { marginLeft: 'auto' }, onClick: closeDialog, children: _jsx(X, {}) })] }), _jsx(DialogContent, { dividers: true, sx: {
                            pb: 1,
                            px: 4
                        }, children: _jsx(Box, { component: 'form', noValidate: true, mt: 1, children: _jsxs(Grid, { container: true, spacing: 1.5, children: [_jsx(Grid, { size: { sm: 6, md: 6 }, spacing: 1.5, children: _jsxs(Box, { display: 'flex', flexDirection: 'column', width: '100%', gap: 1.5, px: 2, sx: { overflowY: 'auto', maxHeight: 'calc(100svh - 260px)' }, children: [_jsx(Grid, { size: { xs: 12, md: 12, sm: 12, lg: 12 }, children: _jsx(Typography, { variant: 'subtitle1', color: theme.palette.text.secondary, children: translate('knowledge.assetInformation') }) }), _jsx(Grid, { size: { xs: 12, md: 12, sm: 12, lg: 12 }, children: _jsx(Controller, { name: 'name', control: control, rules: {
                                                            required: {
                                                                value: true,
                                                                message: tWithField('validations.fieldIsRequired', 'common.name')
                                                            },
                                                            maxLength: {
                                                                value: 256,
                                                                message: translate('validations.maximumCharactersAllowed', { count: 256 })
                                                            }
                                                        }, render: function (_a) {
                                                            var _b;
                                                            var _c = _a.field, onChange = _c.onChange, value = _c.value;
                                                            return (_jsxs(FormControl, { size: 'medium', variant: 'outlined', fullWidth: true, children: [_jsx(TextField, { label: translate('common.name'), type: 'text', fullWidth: true, value: value, onChange: function (e) {
                                                                            var newValue = e.target.value;
                                                                            if ((newValue.length > 2 || newValue.length === 0) &&
                                                                                linkedFiles.length === 0) {
                                                                                triggerMatchingFetch();
                                                                            }
                                                                            onChange(e);
                                                                        }, disabled: isLoading, error: !!errors.name, slotProps: { input: { sx: { borderRadius: '8px' } } } }), _jsx(FormHelperText, { error: true, children: (_b = errors.name) === null || _b === void 0 ? void 0 : _b.message })] }));
                                                        } }) }), _jsx(Grid, { size: { xs: 12, md: 12, sm: 12, lg: 12 }, children: _jsx(Controller, { name: 'type', control: control, rules: {
                                                            required: {
                                                                value: true,
                                                                message: tWithField('validations.fieldIsRequired', 'assets.type')
                                                            },
                                                            maxLength: {
                                                                value: 256,
                                                                message: translate('validations.maximumCharactersAllowed', { count: 256 })
                                                            }
                                                        }, render: function (_a) {
                                                            var _b;
                                                            var _c = _a.field, onChange = _c.onChange, value = _c.value;
                                                            return (_jsxs(FormControl, { variant: 'outlined', size: 'medium', fullWidth: true, children: [_jsx(TextField, { label: translate('assets.type'), type: 'text', fullWidth: true, value: value, onChange: function (e) {
                                                                            var newValue = e.target.value;
                                                                            if ((newValue.length > 2 || newValue.length === 0) &&
                                                                                linkedFiles.length === 0) {
                                                                                triggerMatchingFetch();
                                                                            }
                                                                            onChange(e);
                                                                        }, disabled: isLoading, error: !!errors.type, slotProps: { input: { sx: { borderRadius: '8px' } } } }), _jsx(FormHelperText, { error: true, children: (_b = errors.type) === null || _b === void 0 ? void 0 : _b.message })] }));
                                                        } }) }), _jsx(Grid, { size: { xs: 12, md: 12, sm: 12, lg: 12 }, children: _jsx(Controller, { name: 'brand', control: control, rules: {
                                                            required: {
                                                                value: true,
                                                                message: tWithField('validations.fieldIsRequired', 'assets.brand')
                                                            },
                                                            maxLength: {
                                                                value: 128,
                                                                message: translate('validations.maximumCharactersAllowed', { count: 128 })
                                                            }
                                                        }, render: function (_a) {
                                                            var _b;
                                                            var _c = _a.field, onChange = _c.onChange, value = _c.value;
                                                            return (_jsxs(FormControl, { variant: 'outlined', size: 'medium', fullWidth: true, children: [_jsx(TextField, { label: translate('assets.brand'), type: 'text', fullWidth: true, value: value, onChange: function (e) {
                                                                            var newValue = e.target.value;
                                                                            if ((newValue.length > 2 || newValue.length === 0) &&
                                                                                linkedFiles.length === 0) {
                                                                                triggerMatchingFetch();
                                                                            }
                                                                            onChange(e);
                                                                        }, disabled: isLoading, error: !!errors.brand, slotProps: { input: { sx: { borderRadius: '8px' } } } }), _jsx(FormHelperText, { error: true, children: (_b = errors.brand) === null || _b === void 0 ? void 0 : _b.message })] }));
                                                        } }) }), (currentUser === null || currentUser === void 0 ? void 0 : currentUser.roleCategory) === RoleCategories.SuperAdmin && (_jsx(Grid, { size: { xs: 12 }, children: _jsx(Controller, { name: 'companies', control: control, rules: {
                                                            required: {
                                                                value: true,
                                                                message: tWithField('validations.fieldIsRequired', 'common.company')
                                                            }
                                                        }, render: function (_a) {
                                                            var _b;
                                                            var _c = _a.field, onChange = _c.onChange, value = _c.value;
                                                            return (_jsxs(FormControl, { fullWidth: true, children: [_jsx(Autocomplete, { ref: autocompleteRef, open: openAutoComplete, onOpen: function () { return setOpenAutoComplete(true); }, onClose: function () { return setOpenAutoComplete(false); }, noOptionsText: translate('common.noOptions'), multiple: true, disabled: isLoading || isCompaniesLoading, loading: isCompaniesFetching, options: companies.filter(function (company) { return company.isActive === true; }), value: companies.filter(function (company) {
                                                                            return value.some(function (v) { return v.id === company.id; });
                                                                        }), isOptionEqualToValue: function (option, value) { return option.id === value.id; }, getOptionLabel: function (option) { return option.name; }, disableCloseOnSelect: true, slotProps: { chip: { size: 'small', variant: 'soft' } }, limitTags: 4, renderInput: function (params) { return (_jsx(TextField, __assign({}, params, { variant: 'outlined', fullWidth: true, label: translate('common.company'), error: !!errors.companies }))); }, onChange: function (_, value, reason) {
                                                                            onChange(value.map(function (val) { return ({
                                                                                id: val.id,
                                                                                name: val.name
                                                                            }); }));
                                                                            setValue("clients", []);
                                                                            if (reason === 'clear' || value.length === 1) {
                                                                                setOpenAutoComplete(false);
                                                                            }
                                                                        }, renderOption: function (props, option, _a) {
                                                                            var selected = _a.selected;
                                                                            return (_createElement("li", __assign({}, props, { key: option.id }),
                                                                                _jsx(Checkbox, { style: { marginRight: 8 }, checked: selected }),
                                                                                option.name));
                                                                        }, sx: {
                                                                            '& .MuiOutlinedInput-root': {
                                                                                borderRadius: '8px',
                                                                                '&.MuiInputBase-sizeSmall .MuiAutocomplete-input': {
                                                                                    padding: '3.5px 4px 3.5px 8px'
                                                                                }
                                                                            }
                                                                        } }), _jsx(FormHelperText, { error: true, children: (_b = errors.companies) === null || _b === void 0 ? void 0 : _b.message })] }));
                                                        } }) })), ((currentUser === null || currentUser === void 0 ? void 0 : currentUser.roleCategory) === RoleCategories.SuperAdmin &&
                                                    (currentCompanies === null || currentCompanies === void 0 ? void 0 : currentCompanies.length) === 1) ||
                                                    (currentUser === null || currentUser === void 0 ? void 0 : currentUser.roleCategory) !== RoleCategories.SuperAdmin ? (_jsx(Grid, { size: { xs: 12, md: 12, sm: 12, lg: 12 }, children: _jsx(Controller, { name: 'clients', control: control, render: function (_a) {
                                                            var _b = _a.field, onChange = _b.onChange, value = _b.value;
                                                            return (_jsx(FormControl, { size: 'medium', fullWidth: true, variant: 'outlined', children: _jsx(Autocomplete, { noOptionsText: translate('common.noOptions'), multiple: true, loading: clientsFetching, disabled: isLoading || clientsFetching, options: clients, isOptionEqualToValue: function (option, value) { return option.id === value.id; }, getOptionLabel: function (option) { return option.name; }, disableCloseOnSelect: true, limitTags: 4, slotProps: { chip: { size: 'small', variant: 'soft' } }, renderInput: function (params) { return (_jsx(TextField, __assign({}, params, { variant: 'outlined', fullWidth: true, label: translate('common.clients') }))); }, value: clients.filter(function (client) { return value.includes(client.id); }), onChange: function (_, value) {
                                                                        var selectedIds = value.map(function (client) { return client.id; });
                                                                        onChange(selectedIds);
                                                                    }, renderOption: function (props, option, _a) {
                                                                        var selected = _a.selected;
                                                                        return (_createElement("li", __assign({}, props, { key: option.id }),
                                                                            _jsx(Checkbox, { style: { marginRight: 8 }, checked: selected }),
                                                                            option.name));
                                                                    }, sx: {
                                                                        '& .MuiOutlinedInput-root': {
                                                                            borderRadius: '8px',
                                                                            '&.MuiInputBase-sizeSmall .MuiAutocomplete-input': {
                                                                                padding: '3.5px 4px 3.5px 8px'
                                                                            }
                                                                        }
                                                                    } }) }));
                                                        } }) })) : null, _jsx(ModelNumberBox, { clearErrors: clearErrors, control: control, trigger: trigger, currentClients: currentClients, currentCompanies: currentCompanies, errors: errors, fields: fields, isLoading: isLoading, fileError: fileError, setFileError: setFileError, handleAddModelNumber: handleAddModelNumber, remove: remove, setValue: setValue, tWithField: tWithField, translate: translate, watch: watch, allFiles: allFiles, fileDetails: fileDetails, handleDelink: handleDelink, triggerMatchingFetch: triggerMatchingFetch, machineData: machineData, modelsMadePublic: modelsMadePublic, setModelsMadePublic: setModelsMadePublic, modelsWithErrors: modelsWithErrors, existingModelCount: fields.filter(function (f) { var _a; return (_a = f.modelNumber) === null || _a === void 0 ? void 0 : _a.trim(); }).length, publicFileErrors: publicFileErrors, privateFileErrors: privateFileErrors, onFolderUploadDialogOpen: function (isOpen) {
                                                        // Reset all dialog states when opening/closing
                                                        if (!isOpen) {
                                                            setIsFolderUploadDialogOpen(false);
                                                        }
                                                    }, onFolderUploadDialogDataChange: function (data) {
                                                        // Reset dialog states when new folder data arrives
                                                        setIsFolderUploadDialogOpen(false);
                                                        setFolderUploadDialogData(data);
                                                    } })] }) }), _jsx(Grid, { size: { sm: 6, md: 6 }, spacing: 1.5, children: _jsx(MatchingAsset, { matchingMachines: matchingMachinesData, onLinkAndUnlink: handleLinkAndUnlink, machineData: machineData, isMatchingFetching: isMatchingFetching || isProcessingFolderUpload, isMatchingLoading: isMatchingLoading || isProcessingFolderUpload, watch: watch, linkedMatchingMachines: linkedMatchingMachines, setLinkedMatchingMachine: function (machineId) {
                                                return handleSetLinkedMatchingMachine(machineId);
                                            }, removeLinkedMatchingMachine: function (machineId, removeAll) {
                                                return handleRemoveLinkedMatchingMachine(machineId, removeAll);
                                            } }) })] }) }) }), _jsxs(DialogActions, { sx: { justifyContent: 'space-between', alignItems: 'center' }, children: [_jsxs(Box, { sx: { display: 'flex', alignItems: 'center', gap: 1 }, children: [_jsx(Info, { size: 18, color: theme.palette.info.main }), _jsx(Typography, { variant: 'body2', color: 'text.secondary', children: translate('fileUpload.linkedDocMsg') })] }), _jsx(Box, { children: showFileSizeError && (_jsx(Typography, { variant: 'caption', color: 'error', children: translate('validations.fileSizeLimitExceeded') })) }), _jsxs(Box, { sx: { display: 'flex', gap: 1 }, children: [_jsx(Button, { size: 'medium', variant: 'outlined', color: 'inherit', disabled: isLoading, onClick: closeDialog, children: translate('actions.cancel') }), _jsx(Button, { size: 'medium', variant: 'contained', color: 'inherit', onClick: handleSubmit(handleCreateAsset), disabled: isLoading || showFileSizeError, children: tWithFunction('actions.addFunction', 'common.asset') })] })] })] }), folderUploadDialogData &&
                folderUploadDialogData.isOpen &&
                (function () {
                    var _a, _b;
                    // Map folder structure to FolderUploadDialog format
                    var mapFolderStructure = function () {
                        if (!folderUploadDialogData.folderStructure) {
                            return [];
                        }
                        var modelNumbers = folderUploadDialogData.folderStructure.modelNumbers;
                        return modelNumbers.map(function (modelData, folderIndex) {
                            // Calculate total size for this folder
                            var totalSizeBytes = modelData.files.reduce(function (sum, file) { return sum + file.size; }, 0);
                            var totalSizeMB = totalSizeBytes / (1024 * 1024);
                            var sizeFormatted = totalSizeMB >= 1
                                ? "".concat(totalSizeMB.toFixed(2), " MB")
                                : "".concat((totalSizeBytes / 1024).toFixed(2), " KB");
                            // Map files with IDs
                            var mappedFiles = modelData.files.map(function (file, fileIndex) {
                                var fileSizeFormatted = Number.parseFloat(file.sizeInMB) >= 1
                                    ? "".concat(file.sizeInMB, " MB")
                                    : "".concat((file.size / 1024).toFixed(2), " KB");
                                return {
                                    id: "file-".concat(folderIndex, "-").concat(fileIndex),
                                    fileName: file.fileName,
                                    fileSize: fileSizeFormatted,
                                    isPublic: true, // Default to public, user can toggle
                                    file: file.file // Store the actual File object
                                };
                            });
                            return {
                                id: "folder-".concat(folderIndex),
                                modelNumber: modelData.modelNumber,
                                size: sizeFormatted,
                                files: mappedFiles
                            };
                        });
                    };
                    var mappedFolders = mapFolderStructure();
                    var totalFiles = ((_a = folderUploadDialogData.folderStructure) === null || _a === void 0 ? void 0 : _a.totalFiles) || 0;
                    var totalSizeBytes = mappedFolders.reduce(function (sum, folder) {
                        return (sum +
                            folder.files.reduce(function (fileSum, file) {
                                var sizeMatch = file.fileSize.match(/([\d.]+)\s*(MB|KB)/);
                                if (sizeMatch) {
                                    var value = Number.parseFloat(sizeMatch[1]);
                                    var unit = sizeMatch[2];
                                    return fileSum + (unit === 'MB' ? value * 1024 * 1024 : value * 1024);
                                }
                                return fileSum;
                            }, 0));
                    }, 0);
                    var totalSizeFormatted = totalSizeBytes >= 1024 * 1024
                        ? "".concat((totalSizeBytes / (1024 * 1024)).toFixed(2), " MB")
                        : "".concat((totalSizeBytes / 1024).toFixed(2), " KB");
                    // Calculate existing uploaded file size in MB
                    var existingUploadedSizeBytes = machineData
                        .flatMap(function (data) { return data.files || []; })
                        .filter(function (file) { return !file.isLinked; })
                        .reduce(function (sum, file) { var _a; return sum + (((_a = file.uploadedFile) === null || _a === void 0 ? void 0 : _a.size) || 0); }, 0);
                    var existingUploadedSizeMB = existingUploadedSizeBytes / (1024 * 1024);
                    // Calculate existing model count excluding the default empty entry
                    var hasDefaultEmptyEntry = fields.length === 1 &&
                        fields[0].modelNumber === '' &&
                        fields[0].files.length === 0 &&
                        fields[0].serialNumbers.length === 1 &&
                        fields[0].serialNumbers[0].serialNumber === '';
                    var actualExistingModelCount = hasDefaultEmptyEntry ? 0 : fields.length;
                    return (_jsx(FolderUploadDialog, { open: true, existingModelCount: actualExistingModelCount, existingFileSizeMB: existingUploadedSizeMB, onOpen: function () {
                            setIsFolderUploadDialogOpen(true);
                        }, onClose: function () {
                            setFolderUploadDialogData(null);
                            setIsFolderUploadDialogOpen(false);
                        }, onConfirm: function (selectedFileIds, fieldType, fileVisibility) { return __awaiter(void 0, void 0, void 0, function () {
                            var _a, parentFolderName, modelNumbers, currentFieldValue, selectedFileSet_1, hasDefaultEmptyEntry_1, updatedMachineData_1, corruptedFilesMap_1, validatePDF_1, _loop_1, _b, _c, _d, folderIndex, folder, e_1_1, modelsWithOnlyCorruptedFiles, i, modelIndicesWithErrors_1, hasPublicFiles;
                            var e_1, _e;
                            var _f, _g;
                            return __generator(this, function (_h) {
                                switch (_h.label) {
                                    case 0:
                                        if (!folderUploadDialogData.folderStructure) return [3 /*break*/, 9];
                                        _a = folderUploadDialogData.folderStructure, parentFolderName = _a.parentFolderName, modelNumbers = _a.modelNumbers;
                                        currentFieldValue = watch(fieldType);
                                        if (!currentFieldValue || currentFieldValue.trim() === '') {
                                            setValue(fieldType, parentFolderName, { shouldValidate: true });
                                        }
                                        selectedFileSet_1 = new Set(selectedFileIds);
                                        hasDefaultEmptyEntry_1 = machineData.length === 1 &&
                                            machineData[0].modelNumber === '' &&
                                            machineData[0].files.length === 0 &&
                                            machineData[0].serialNumbers.length === 1 &&
                                            machineData[0].serialNumbers[0].serialNumber === '';
                                        updatedMachineData_1 = hasDefaultEmptyEntry_1 ? [] : __spreadArray([], __read(machineData), false);
                                        corruptedFilesMap_1 = {};
                                        validatePDF_1 = function (file) { return __awaiter(void 0, void 0, void 0, function () {
                                            var arrayBuffer, _a;
                                            return __generator(this, function (_b) {
                                                switch (_b.label) {
                                                    case 0:
                                                        _b.trys.push([0, 3, , 4]);
                                                        return [4 /*yield*/, file.arrayBuffer()];
                                                    case 1:
                                                        arrayBuffer = _b.sent();
                                                        return [4 /*yield*/, pdfJs.getDocument({ data: arrayBuffer }).promise];
                                                    case 2:
                                                        _b.sent();
                                                        return [2 /*return*/, true];
                                                    case 3:
                                                        _a = _b.sent();
                                                        return [2 /*return*/, false];
                                                    case 4: return [2 /*return*/];
                                                }
                                            });
                                        }); };
                                        _loop_1 = function (folderIndex, folder) {
                                            var selectedFolderFiles, originalModelData, validationResults, validFiles, corruptedFiles, validationResults_1, validationResults_1_1, res, mf, isPublic, existingModelIndex, existingFiles, existingFileNames_1, filesToAdd;
                                            var e_2, _j;
                                            return __generator(this, function (_k) {
                                                switch (_k.label) {
                                                    case 0:
                                                        selectedFolderFiles = folder.files.filter(function (f) {
                                                            return selectedFileSet_1.has(f.id);
                                                        });
                                                        if (selectedFolderFiles.length === 0)
                                                            return [2 /*return*/, "continue"];
                                                        originalModelData = modelNumbers[folderIndex];
                                                        return [4 /*yield*/, Promise.all(selectedFolderFiles.map(function (mappedFile) { return __awaiter(void 0, void 0, void 0, function () {
                                                                var originalFile, fileObj, isValid;
                                                                return __generator(this, function (_a) {
                                                                    switch (_a.label) {
                                                                        case 0:
                                                                            originalFile = originalModelData.files.find(function (f) { return f.fileName === mappedFile.fileName; });
                                                                            fileObj = originalFile === null || originalFile === void 0 ? void 0 : originalFile.file;
                                                                            if (!(fileObj && fileObj instanceof File)) return [3 /*break*/, 2];
                                                                            return [4 /*yield*/, validatePDF_1(fileObj)];
                                                                        case 1:
                                                                            isValid = _a.sent();
                                                                            return [2 /*return*/, { mappedFile: mappedFile, originalFile: originalFile, isValid: isValid }];
                                                                        case 2: 
                                                                        // If we don't have a File object, treat as invalid to be safe
                                                                        return [2 /*return*/, { mappedFile: mappedFile, originalFile: originalFile, isValid: false }];
                                                                    }
                                                                });
                                                            }); }))];
                                                    case 1:
                                                        validationResults = _k.sent();
                                                        validFiles = [];
                                                        corruptedFiles = [];
                                                        try {
                                                            for (validationResults_1 = (e_2 = void 0, __values(validationResults)), validationResults_1_1 = validationResults_1.next(); !validationResults_1_1.done; validationResults_1_1 = validationResults_1.next()) {
                                                                res = validationResults_1_1.value;
                                                                mf = res.mappedFile;
                                                                isPublic = (_f = fileVisibility[mf.id]) !== null && _f !== void 0 ? _f : true;
                                                                if (res.isValid) {
                                                                    validFiles.push({
                                                                        id: nanoid(),
                                                                        uploadedFile: ((_g = res.originalFile) === null || _g === void 0 ? void 0 : _g.file) || null,
                                                                        uploaded: true,
                                                                        fileName: mf.fileName,
                                                                        isDownloadable: false,
                                                                        isLinked: false,
                                                                        linkedDocumentId: null,
                                                                        isPublic: isPublic
                                                                    });
                                                                }
                                                                else {
                                                                    corruptedFiles.push({ fileName: mf.fileName, isPublic: isPublic });
                                                                }
                                                            }
                                                        }
                                                        catch (e_2_1) { e_2 = { error: e_2_1 }; }
                                                        finally {
                                                            try {
                                                                if (validationResults_1_1 && !validationResults_1_1.done && (_j = validationResults_1.return)) _j.call(validationResults_1);
                                                            }
                                                            finally { if (e_2) throw e_2.error; }
                                                        }
                                                        if (corruptedFiles.length > 0) {
                                                            corruptedFilesMap_1[folder.modelNumber] = corruptedFiles;
                                                        }
                                                        existingModelIndex = updatedMachineData_1.findIndex(function (data) {
                                                            return data.modelNumber.trim().toLowerCase() ===
                                                                folder.modelNumber.trim().toLowerCase();
                                                        });
                                                        if (existingModelIndex !== -1) {
                                                            existingFiles = updatedMachineData_1[existingModelIndex].files || [];
                                                            existingFileNames_1 = new Set(existingFiles.map(function (f) { return f.fileName; }));
                                                            filesToAdd = validFiles.filter(function (f) { return !existingFileNames_1.has(f.fileName); });
                                                            updatedMachineData_1[existingModelIndex] = __assign(__assign({}, updatedMachineData_1[existingModelIndex]), { files: __spreadArray(__spreadArray([], __read(existingFiles), false), __read(filesToAdd), false) });
                                                        }
                                                        else if (validFiles.length > 0) {
                                                            // Only create a new entry if there are valid files for it
                                                            updatedMachineData_1.push({
                                                                modelNumber: folder.modelNumber,
                                                                serialNumbers: [],
                                                                files: validFiles
                                                            });
                                                        }
                                                        return [2 /*return*/];
                                                }
                                            });
                                        };
                                        _h.label = 1;
                                    case 1:
                                        _h.trys.push([1, 6, 7, 8]);
                                        _b = __values(mappedFolders.entries()), _c = _b.next();
                                        _h.label = 2;
                                    case 2:
                                        if (!!_c.done) return [3 /*break*/, 5];
                                        _d = __read(_c.value, 2), folderIndex = _d[0], folder = _d[1];
                                        return [5 /*yield**/, _loop_1(folderIndex, folder)];
                                    case 3:
                                        _h.sent();
                                        _h.label = 4;
                                    case 4:
                                        _c = _b.next();
                                        return [3 /*break*/, 2];
                                    case 5: return [3 /*break*/, 8];
                                    case 6:
                                        e_1_1 = _h.sent();
                                        e_1 = { error: e_1_1 };
                                        return [3 /*break*/, 8];
                                    case 7:
                                        try {
                                            if (_c && !_c.done && (_e = _b.return)) _e.call(_b);
                                        }
                                        finally { if (e_1) throw e_1.error; }
                                        return [7 /*endfinally*/];
                                    case 8:
                                        modelsWithOnlyCorruptedFiles = Object.keys(corruptedFilesMap_1).filter(function (modelNumber) {
                                            return !updatedMachineData_1.some(function (data) {
                                                return data.modelNumber.trim().toLowerCase() === modelNumber.trim().toLowerCase();
                                            });
                                        });
                                        // Add entries for models with only corrupted files so errors can be shown
                                        modelsWithOnlyCorruptedFiles.forEach(function (modelNumber) {
                                            updatedMachineData_1.push({
                                                modelNumber: modelNumber,
                                                serialNumbers: [],
                                                files: []
                                            });
                                        });
                                        // 4. Update form with merged data
                                        if (updatedMachineData_1.length > 0) {
                                            // Clear all existing entries
                                            for (i = machineData.length - 1; i >= 0; i--) {
                                                remove(i);
                                            }
                                            // Append all updated/merged entries
                                            updatedMachineData_1.forEach(function (data) { return append(data); });
                                            modelIndicesWithErrors_1 = [];
                                            // After appending, set field errors for models that had corrupted files
                                            // Use setTimeout to ensure form fields are registered before setting errors
                                            setTimeout(function () {
                                                var newPublicFileErrors = {};
                                                var newPrivateFileErrors = {};
                                                for (var i = 0; i < updatedMachineData_1.length; i++) {
                                                    var model = updatedMachineData_1[i];
                                                    var corrupted = corruptedFilesMap_1[model.modelNumber];
                                                    if (corrupted && corrupted.length > 0) {
                                                        // Check if ALL files in this model were corrupted (no valid files)
                                                        var hasValidFiles = model.files && model.files.length > 0;
                                                        // Separate corrupted files by visibility
                                                        var corruptedPublicFiles = corrupted.filter(function (f) { return f.isPublic; });
                                                        var corruptedPrivateFiles = corrupted.filter(function (f) { return !f.isPublic; });
                                                        // Build error messages for public and private files separately
                                                        if (corruptedPublicFiles.length > 0) {
                                                            if (!hasValidFiles && corruptedPrivateFiles.length === 0) {
                                                                // All files were public and corrupted
                                                                newPublicFileErrors[i] = translate('fileUpload.allFilesCorruptedError');
                                                            }
                                                            else {
                                                                // Some public files corrupted
                                                                newPublicFileErrors[i] = corruptedPublicFiles
                                                                    .map(function (f) { return tWithField('fileUpload.corruptedFileError', f.fileName); })
                                                                    .join('\n');
                                                            }
                                                        }
                                                        if (corruptedPrivateFiles.length > 0) {
                                                            if (!hasValidFiles && corruptedPublicFiles.length === 0) {
                                                                // All files were private and corrupted
                                                                newPrivateFileErrors[i] = translate('fileUpload.allFilesCorruptedError');
                                                            }
                                                            else {
                                                                // Some private files corrupted
                                                                newPrivateFileErrors[i] = corruptedPrivateFiles
                                                                    .map(function (f) { return tWithField('fileUpload.corruptedFileError', f.fileName); })
                                                                    .join('\n');
                                                            }
                                                        }
                                                        modelIndicesWithErrors_1.push(i);
                                                    }
                                                }
                                                // Update state with errors
                                                setPublicFileErrors(newPublicFileErrors);
                                                setPrivateFileErrors(newPrivateFileErrors);
                                                // Set state to keep accordions with errors open
                                                setModelsWithErrors(modelIndicesWithErrors_1);
                                            }, 100);
                                        }
                                        hasPublicFiles = updatedMachineData_1.some(function (data) {
                                            return data.files.some(function (f) { return f.isPublic; });
                                        });
                                        if (hasPublicFiles) {
                                            setIsProcessingFolderUpload(true);
                                            triggerMatchingFetch();
                                            // Reset processing state after debounce + fetch time
                                            setTimeout(function () { return setIsProcessingFolderUpload(false); }, 2000);
                                        }
                                        _h.label = 9;
                                    case 9:
                                        // Close dialogs
                                        setFolderUploadDialogData(null);
                                        setIsFolderUploadDialogOpen(false);
                                        return [2 /*return*/];
                                }
                            });
                        }); }, assets: [
                            {
                                id: '1',
                                name: ((_b = folderUploadDialogData.folderStructure) === null || _b === void 0 ? void 0 : _b.parentFolderName) || 'Asset'
                            }
                        ], selectedAssetId: '1', folders: mappedFolders, folderCount: mappedFolders.length, documentCount: totalFiles, totalSize: totalSizeFormatted }));
                })()] }));
};
export default AddMachine;
